import type { TagCategory } from '~/ducks/asset-tags/data/Tag';
import BFFAPI from './utils/BFFAPI';

export type AvailableTagsReturnType = TagCategory[];

class AssetTagCategoriesAPI extends BFFAPI {
  getAvailableTagCategories = () => {
    const req = this.fetchHelper.createGetRequest(`${this.endpoint}`);
    return this.fetch(req);
  };

  createTagCategory = (name: string) => {
    const req = this.fetchHelper.createPostRequest(`${this.endpoint}`, {
      name,
    });
    return this.fetch(req);
  };

  updateTagCategory = (categoryId: string, newName: string) => {
    const req = this.fetchHelper.createPatchRequest(
      `${this.endpoint}/${categoryId}`,
      {
        name: newName,
      }
    );
    return this.fetch(req);
  };

  deleteTagCategory = (categoryId: string) => {
    const req = this.fetchHelper.createDeleteRequest(
      `${this.endpoint}/${categoryId}`
    );
    return this.fetch(req);
  };
}

export default new AssetTagCategoriesAPI('/fleet/secure/tag-categories');
